export default __webpack_public_path__ + "static/media/O-133.c26fd8e6.png";